import React, { FC, useState } from 'react';
import { Create, CreateProps, TabbedForm } from 'react-admin';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
import UserGeneralTab from './GeneralTab';
import UserToolbar from './UserToolbar';
import './index.css'


const AddUser: FC<CreateProps> = (props) => {
    const [state, setState] = useState({
        isBlocked: false
    })

    const changeStatus = () => {
        setState({ ...state, isBlocked: !state.isBlocked })
    }

    return (
        <>
            <DocumentTitle core="User" secondary="Users" purpose="Add new" appointment="User" />
       
            <Create {...props}>
                <TabbedForm tabs={<Tabbed />} toolbar={UserToolbar(props, true, state.isBlocked)}>
                    <UserGeneralTab isBlocked={state.isBlocked} changeStatus={changeStatus} isShow={false} />
                </TabbedForm>
            </Create>
        </>
    )
}


const Tabbed = () => {
    return (<></>)
}

export default AddUser